import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Contacts from "../components/Contacts";
import Layout from "../components/Layout";
import { Typography, Box } from "@mui/material";
import images from "../utils/loadImages";
import styles from "../styles/Blog.module.css";

const Blog = () => {
	const contactRef = useRef(null);
	const [imageSizes, setImageSizes] = useState([]);
	const [activeImage, setActiveImage] = useState(null);

	const handleContactClick = () => {
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	useEffect(() => {
		const loadImageSizes = async () => {
			const sizes = await Promise.all(
				images.map((src) => {
					return new Promise((resolve) => {
						const img = new Image();
						img.src = src;
						img.onload = () => {
							const aspectRatio = img.width / img.height;
							resolve(aspectRatio);
						};
					});
				})
			);
			setImageSizes(sizes);
		};

		loadImageSizes();
	}, []);

	const handleImageClick = (index) => {
		setActiveImage(index === activeImage ? null : index);
	};

	const imageTexts = [
		"Picked up golf",
		"Biking on a nice day",
		"Peak of Grouse Mountain",
		"Back to back championships",
		"Taking off from Hong Kong",
		"Orillia, CA",
		"Buffalo, US",
		"Toronto, CA",
		"Cypress Mountain",
		"Taichung, TW",
		"Yi Tung Shan, HK",
		"Victoria Prison, HK",
		"Victoria Prison, HK",
		"Kwun Tong, HK",
		"Kashima Soccer Stadium",
		"Sawara, JP",
		"Tokyo, JP",
		"The popped duck",
		"Macao Tower",
		"Taipei 101",
		"Tokyo, JP",
		"BMO Field, CA"
	];

	return (
		<div className={styles.root}>
			<Header onContactClick={handleContactClick} />
			<Typography
				variant="h4"
				align="center"
				gutterBottom
				sx={{ marginTop: "20px", fontWeight: "bold", fontStyle: "italic" }}
			>
				My Sanctuary
			</Typography>
			<Box className={styles.collage}>
				{images.map((image, index) => {
					const aspectRatio = imageSizes[index];
					let className = styles.small;
					if (aspectRatio > 1.5) {
						className = styles.large;
					} else if (aspectRatio > 1) {
						className = styles.medium;
					}
					return (
						<Box
							key={index}
							className={className}
							onClick={() => handleImageClick(index)}
							sx={{ position: "relative", cursor: "pointer" }}
						>
							<img
								src={image}
								alt={`Blog ${index + 1}`}
								className={styles.img}
							/>
							<Box
								className={`${styles.overlay} ${
									activeImage === index ? styles.active : ""
								}`}
								sx={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									color: "white",
									fontSize: "1.2rem"
								}}
							>
								{imageTexts[index]}
							</Box>
						</Box>
					);
				})}
			</Box>
			<Layout>
				<Box ref={contactRef}></Box>
				<Contacts />
			</Layout>
		</div>
	);
};

export default Blog;
